var _rect, _rect2, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockedFreeMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 21,
    viewBox: "0 0 64 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.910583,
    width: 64,
    height: 20,
    rx: 10,
    fill: "#474B5A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_770",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.910583,
    width: 64,
    height: 20,
    rx: 10,
    fill: "#1CADE4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_770)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.1521,
    y: -15.415,
    width: 55.2,
    height: 48,
    transform: "rotate(15 39.1521 -15.415)",
    fill: "#1CADE4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8003 6.20648C21.5341 5.94027 21.1041 5.94027 20.8379 6.20648L17.5 9.53754L14.1621 6.19966C13.8959 5.93345 13.4659 5.93345 13.1997 6.19966C12.9334 6.46587 12.9334 6.8959 13.1997 7.16212L16.5375 10.5L13.1997 13.8379C12.9334 14.1041 12.9334 14.5341 13.1997 14.8003C13.4659 15.0666 13.8959 15.0666 14.1621 14.8003L17.5 11.4625L20.8379 14.8003C21.1041 15.0666 21.5341 15.0666 21.8003 14.8003C22.0666 14.5341 22.0666 14.1041 21.8003 13.8379L18.4625 10.5L21.8003 7.16212C22.0597 6.90273 22.0597 6.46587 21.8003 6.20648Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedFreeMale);
export default __webpack_public_path__ + "static/media/blocked-free-male.ecfbc2a681758dc3d55be318a2d8c2c7.svg";
export { ForwardRef as ReactComponent };